import React, { Component } from "react";
import { MyDraggable as Draggable, Dropzone } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { generateStyle, l, setOverLay } from "../functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "../components/Icons";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import state from "../state";

function mapStateToProps(state) {
  return {
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

export class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: null,
      version: 1,
      initialElements: [],
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // const { id, dropzoneID, parentID } = this.props;
    const { id, dropzoneID, parentID, payload } = this.props;

    if (
      JSON.stringify(prevState.initialElements) !==
      JSON.stringify(this.state.initialElements)
    ) {
      let updatedObject = {};

      updatedObject.initialElements = this.state.initialElements;
      updatedObject.fields = this.state.initialElements;

      state.updateElement(id, dropzoneID, parentID, updatedObject);
    }
  }
  componentDidMount() {
    this.setState({
      initialElements: this.props.initialElements,
      frameVersion: Math.random(),
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.initialElements);
    if (this.state.initialElements !== nextProps?.initialElements) {
      this.setState({
        initialElements: nextProps.initialElements,
        frameVersion: Math.random(),
      });
    }

    if (!this.state.currentTab) {
      const { datas: { tabs = [] } = {} } = nextProps.payload || {};
      if (tabs?.length > 0) {
        this.setState({ currentTab: tabs[0]?.id });
      }
    }
  }

  _filterInitialElements = (dID) => {
    let elements = [];
    const { fields } = this.props;
    if (fields !== undefined) {
      elements = fields && fields.filter((e) => e.dropzoneID === dID);
    }

    return elements;
  };

  _generateTabHeadStyle = (payload) => {
    const { tabBackground, tabBorder } = payload;
    // console.log(tabBackground, tabBorder);

    let style = {};

    //boder style
    style.borderTopLeftRadius = tabBorder?.lt || 0;
    style.borderTopRightRadius = tabBorder?.rt || 0;
    style.borderColor = tabBorder?.border_color || "black";

    if (tabBorder?.border_target === "border") {
      style.borderStyle = tabBorder?.border_style || null;

      style.borderWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderTop") {
      style.borderTopStyle = tabBorder?.border_style || null;
      style.borderTopWidth = tabBorder?.border_width || null;
    }

    if (tabBorder?.border_target === "borderRight") {
      style.borderRightStyle = tabBorder?.border_style || null;
      style.borderRightWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = tabBorder?.border_style || null;
      style.borderLeftWidth = tabBorder?.border_width || null;
    }
    if (tabBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = tabBorder?.border_style || null;
      style.borderBottomWidth = tabBorder?.border_width || null;
    }

    // background

    if (tabBackground?.backgroundColor) {
      style.backgroundColor = tabBackground?.backgroundColor;
    }

    if (tabBackground?.backgroundImage) {
      style.backgroundImage = tabBackground?.backgroundImage
        ? `url(${tabBackground.backgroundImage})`
        : null;
      style.backgroundSize = tabBackground.backgroundSize || null;
      style.backgroundRepeat = tabBackground.backgroundRepeat || null;
      style.backgroundPosition = tabBackground.backgroundPosition || null;
      style.backgroundAttachment = tabBackground.parallax ? "fixed" : null;
    }
    /*

{
    "backgroundColor": "rgba(0,0,0,1)",
    "backgroundImage": "https://cdn.groovekart.com/xxxxxxxx/img/m3q6CmGFgPV3jaYe0Q8oBRryYDEhbN.webp",
    "backgroundSize": "initial",
    "backgroundRepeat": "repeat",
    "backgroundPosition": "center center",
    "overlayOpacity": 24,
    "parallax": true
}

    */

    return style;
  };

  _generateActiveTabStyle = (payload) => {
    const { activeTabBackground, activeTabBorder, activeTabFont } = payload;

    let style = {};

    // border

    style.borderTopLeftRadius = activeTabBorder?.lt || 0;
    style.borderTopRightRadius = activeTabBorder?.rt || 0;
    style.borderColor = activeTabBorder?.border_color || "black";

    if (activeTabBorder?.border_target === "border") {
      style.borderStyle = activeTabBorder?.border_style || null;

      style.borderWidth = activeTabBorder?.border_width || null;
    }
    if (activeTabBorder?.border_target === "borderTop") {
      style.borderTopStyle = activeTabBorder?.border_style || null;
      style.borderTopWidth = activeTabBorder?.border_width || null;
    }

    if (activeTabBorder?.border_target === "borderRight") {
      style.borderRightStyle = activeTabBorder?.border_style || null;
      style.borderRightWidth = activeTabBorder?.border_width || null;
    }
    if (activeTabBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = activeTabBorder?.border_style || null;
      style.borderLeftWidth = activeTabBorder?.border_width || null;
    }
    if (activeTabBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = activeTabBorder?.border_style || null;
      style.borderBottomWidth = activeTabBorder?.border_width || null;
    }

    // background

    if (activeTabBackground?.backgroundColor) {
      style.backgroundColor = activeTabBackground?.backgroundColor;
    }

    if (activeTabBackground?.backgroundImage) {
      style.backgroundImage = activeTabBackground?.backgroundImage
        ? `url(${activeTabBackground.backgroundImage})`
        : null;
      style.backgroundSize = activeTabBackground.backgroundSize || null;
      style.backgroundRepeat = activeTabBackground.backgroundRepeat || null;
      style.backgroundPosition = activeTabBackground.backgroundPosition || null;
      style.backgroundAttachment = activeTabBackground.parallax
        ? "fixed"
        : null;
    }

    // font

    if (activeTabFont) {
      style.fontSize = activeTabFont?.fontSize || 32;
      style.color = activeTabFont?.color || "black";
    }

    return style;
  };

  _generateInactiveTabStyle = (payload) => {
    const { inactiveTabBackground, inactiveTabBorder, inactiveTabFont } =
      payload;

    let style = {};

    // border

    style.borderTopLeftRadius = inactiveTabBorder?.lt || 0;
    style.borderTopRightRadius = inactiveTabBorder?.rt || 0;
    style.borderColor = inactiveTabBorder?.border_color || "black";

    if (inactiveTabBorder?.border_target === "border") {
      style.borderStyle = inactiveTabBorder?.border_style || null;

      style.borderWidth = inactiveTabBorder?.border_width || null;
    }
    if (inactiveTabBorder?.border_target === "borderTop") {
      style.borderTopStyle = inactiveTabBorder?.border_style || null;
      style.borderTopWidth = inactiveTabBorder?.border_width || null;
    }

    if (inactiveTabBorder?.border_target === "borderRight") {
      style.borderRightStyle = inactiveTabBorder?.border_style || null;
      style.borderRightWidth = inactiveTabBorder?.border_width || null;
    }
    if (inactiveTabBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = inactiveTabBorder?.border_style || null;
      style.borderLeftWidth = inactiveTabBorder?.border_width || null;
    }
    if (inactiveTabBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = inactiveTabBorder?.border_style || null;

      style.borderBottomWidth = inactiveTabBorder?.border_width || null;
    }

    // background

    if (inactiveTabBackground?.backgroundColor) {
      style.backgroundColor = inactiveTabBackground?.backgroundColor;
    }

    if (inactiveTabBackground?.backgroundImage) {
      style.backgroundImage = inactiveTabBackground?.backgroundImage
        ? `url(${inactiveTabBackground.backgroundImage})`
        : null;
      style.backgroundSize = inactiveTabBackground.backgroundSize || null;
      style.backgroundRepeat = inactiveTabBackground.backgroundRepeat || null;
      style.backgroundPosition =
        inactiveTabBackground.backgroundPosition || null;
      style.backgroundAttachment = inactiveTabBackground.parallax
        ? "fixed"
        : null;
    }

    // font

    if (inactiveTabFont) {
      style.fontSize = inactiveTabFont?.fontSize || 32;
      style.color = inactiveTabFont?.color || "black";
    }
    return style;
  };

  _generateContentStyle = (payload) => {
    const { contentBackground, contentBorder } = payload;

    let style = {};

    //boder style
    style.borderBottomLeftRadius = contentBorder?.lb || 0;
    style.borderBottomRightRadius = contentBorder?.rb || 0;
    style.borderColor = contentBorder?.border_color || "black";

    if (contentBorder?.border_target === "border") {
      style.borderStyle = contentBorder?.border_style || null;
      style.borderWidth = contentBorder?.border_width || null;
    }
    if (contentBorder?.border_target === "borderTop") {
      style.borderTopStyle = contentBorder?.border_style || null;
      style.borderTopWidth = contentBorder?.border_width || null;
    }

    if (contentBorder?.border_target === "borderRight") {
      style.borderRightStyle = contentBorder?.border_style || null;
      style.borderRightWidth = contentBorder?.border_width || null;
    }
    if (contentBorder?.border_target === "borderLeft") {
      style.borderLeftStyle = contentBorder?.border_style || null;
      style.borderLeftWidth = contentBorder?.border_width || null;
    }
    if (contentBorder?.border_target === "borderBottom") {
      style.borderBottomStyle = contentBorder?.border_style || null;
      style.borderBottomWidth = contentBorder?.border_width || null;
    }

    // background

    if (contentBackground?.backgroundColor) {
      style.backgroundColor = contentBackground?.backgroundColor;
    }

    if (contentBackground?.backgroundImage) {
      style.backgroundImage = contentBackground?.backgroundImage
        ? `url(${contentBackground.backgroundImage})`
        : null;
      style.backgroundSize = contentBackground.backgroundSize || null;
      style.backgroundRepeat = contentBackground.backgroundRepeat || null;
      style.backgroundPosition = contentBackground.backgroundPosition || null;
      style.backgroundAttachment = contentBackground.parallax ? "fixed" : null;
    }
    /*

{
    "backgroundColor": "rgba(0,0,0,1)",
    "backgroundImage": "https://cdn.groovekart.com/xxxxxxxx/img/m3q6CmGFgPV3jaYe0Q8oBRryYDEhbN.webp",
    "backgroundSize": "initial",
    "backgroundRepeat": "repeat",
    "backgroundPosition": "center center",
    "overlayOpacity": 24,
    "parallax": true
}

    */

    return style;
  };

  _tabSpacing = (settings) => {
    const { tabSpacing: spacing } = settings;
    return {
      marginTop: (spacing && spacing.marginTop) || null,
      marginBottom: (spacing && spacing.marginBottom) || null,
      marginRight: (spacing && spacing.marginRight) || null,
      marginLeft: (spacing && spacing.marginLeft) || null,

      paddingTop: (spacing && spacing.paddingTop) || null,
      paddingBottom: (spacing && spacing.paddingBottom) || null,
      paddingRight: (spacing && spacing.paddingRight) || null,
      paddingLeft: (spacing && spacing.paddingLeft) || null,
    };
  };

  _onDrop = (data, cb) => {
    // no need to ask id and name again
    if (data.payload && data.payload.dropped) {
      return cb(data);
    }

    // This can be an async call or some modal to fetch data

    let name = data.name;
    const id = "gk-" + Math.floor(Math.random() * 10000 + 1);

    return cb({
      ...data,
      name,
      id,
      elementId: data.id,
      payload: {
        dropped: true,
        ...this.props.elementOptions[data.id]?.payload,
      },
    });
  };

  _generateTabs = (payload, dropzoneProps) => {
    const { datas } = payload || {};
    const settings =
      payload["settings+" + this.props.currentDevice] || payload.settings;

    const { tabs = [], tabsSettings } = datas;

    const activeTabCss = this._generateActiveTabStyle(settings);

    const inactiveTabCss = this._generateInactiveTabStyle(settings);

    const tabHeadCss = this._generateTabHeadStyle(settings);
    const tabContentCss = this._generateContentStyle(settings);

    const tabSpacing = this._tabSpacing(settings);

    const cssSettings = generateStyle(payload, "container");
    const cssTextSettings = generateStyle(payload, "text", "H3");

    console.log(payload.settings);

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        <Row>
          <Col>
            <div className="tabs-container">
              <div className="tabs-head" style={tabHeadCss}>
                {tabs.map(({ id, data: { title_1 } = {} }, index) => {
                  return (
                    <>
                      <div
                        key={id}
                        className={`head`}
                        style={{
                          ...cssTextSettings,
                          ...(this.state.currentTab === id
                            ? activeTabCss
                            : inactiveTabCss),
                          ...tabSpacing,
                        }}
                        onClick={() => this.setState({ currentTab: id })}
                      >
                        <span>{title_1 || "Tab " + (index + 1)}</span>
                      </div>
                    </>
                  );
                })}
              </div>
              <div className="tabs-content" style={tabContentCss}>
                {tabs.map(({ id, data }, index) => {
                  return (
                    this.state.currentTab === id && (
                      <>
                        <Dropzone
                          {...dropzoneProps}
                          initialElements={this._filterInitialElements(
                            `canvas-${id}`
                          )}
                          id={`canvas-${id}`}
                          key={`canvas-${id}`}
                          onDrop={this._onDrop}
                          placeholder={"Tab Content"}
                          version={`canvas-${id}-${this.state.frameVersion}`}
                        />
                      </>
                    )
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }
    return (
      <Draggable {...this.props} row={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._generateTabs(payload, dropzoneProps)}
      </Draggable>
    );
  }
}

export default connect(mapStateToProps)(Tabs);
